var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ph-compare-category"},[_c('el-backtop'),(_vm.showHeader)?_c('hpheader'):_vm._e(),_c('ph-category'),_c('hpfooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }